import TenderInfoView from "./components/view/tender-info-view"; // Update the path as needed

export default function TenderPage() {
  return (
    <div
      className="flex flex-col overflow-x-hidden"
      style={{ background: "#f8fafa !important" }}
    >
      <div className="xs:flex xs:flex-col items-center">
        <main className="flex items-center w-full flex-col">
          <section className="w-full bg-primary-white p-5 rounded-md py-6">
            <TenderInfoView />
          </section>
        </main>
      </div>

    </div>
  );
}
